import {Component, OnInit} from '@angular/core';
import {DataStorageService} from '../../../../data-storage.service';
import {Internet} from '../../../../../models/internet';
import {ApiService} from '../../../../api.service';

@Component({
  selector: 'app-cyber-internet',
  templateUrl: './cyber-internet.component.html',
  styleUrls: ['./cyber-internet.component.scss']
})
export class CyberInternetComponent implements OnInit {
  technologies: string[];
  IPaddress: string[];
  SLAlevel: string[];
  supportT: string[];
  routers: string[];
  ENDToend: string[];
  toggle: boolean = false;

  constructor(public dataStorageService: DataStorageService,
              private api: ApiService,
  ) {

    this.technologies = [];
    this.SLAlevel = [];
    this.supportT = [];
    const technologies = new Set();
    this.dataStorageService.ispPricingCYBERLINK.map(e => {
      technologies.add(e.technology);
    });
    this.technologies = Array.from(technologies);

    const IPs = new Set();
    this.dataStorageService.addressCYBERLINK.map(i => {
      IPs.add(i.option);
    });
    this.IPaddress = Array.from(IPs);

    const SLA = new Set();
    this.dataStorageService.slaCYBERLINK.map(l => {
      SLA.add(l.option);
    });
    this.SLAlevel = Array.from(SLA);

    const ST = new Set();
    this.dataStorageService.supportTimeCYBERLINK.map(s => {
      ST.add(s.option);
    });
    this.supportT = Array.from(ST);

    const RT = new Set();
      this.dataStorageService.typeOfRouterCYBERLINK.map(r => {
        if ((r.option !== 'Managed Router')) {
            RT.add(r.option);
        }
      });
    this.routers = Array.from(RT);
    const EDT = new Set();
    this.dataStorageService.endtoend.map(r => {
      EDT.add(r.option);
    });
    this.ENDToend = Array.from(EDT);
  }

  ngOnInit() {
    const offerID = this.dataStorageService.currentState.offerID;
    if (this.dataStorageService.currentState.offerID !== 0) {
      this.api.getInternet(offerID, 'CYBERLINK');
    }
  }

  filterbandwidths(tech: string, sla: string) {
    const filtered = this.dataStorageService.ispPricingCYBERLINK.filter((e) => {
      return e.technology === tech;
    });
    const toReturn = new Set();
    filtered.map(e => {
      let skip = false;
      //filter out bandwidth >1000 if sla is managed
      if(sla != 'Unmanaged'){
          let values = e.bandwidth.split("/");
          if(parseInt(values[0]) > 1000 || parseInt(values[1]) > 1000 ){
              skip = true;
          }
      }
      if(!skip){
          toReturn.add(e.bandwidth);
      }
    });
    return Array.from(toReturn);
  }

  filterRouters(tech: string, ip: string) {
    let ipType = 'DHCP';

    if (ip != 'DHCP') {
      ipType = 'static IP'
    }

    return this.routers.filter(rt =>  rt == 'No router' || rt.includes(tech) && (rt.includes(ipType) || rt.includes('Bridge')))
  }

  selectSlaBasi(element) {
    if (element != 'Unmanaged') {
      return true;
    }
    return false;
  }
  addInternetConnClick() {
    const dummy: Internet = new Internet();
    dummy.type = 'CYBERLINK';
    this.toggle = !this.toggle;
    dummy.technology = this.technologies[0];
    dummy.bandwidth = this.filterbandwidths(dummy.technology, dummy.slaLevel)[0];
    dummy.slaLevel = 'Unmanaged';
    dummy.supportTime = this.supportT[0];
    dummy.ipAddress = this.IPaddress[0];
    dummy.router = this.routers[0];
    dummy.checkendtoend = false;
    dummy.checkSim = false;
    dummy.checkDsl = false;
    const i = this.dataStorageService.currentState.PPinternetCyberlink.internet.length - 1;
    dummy['technologyMonthly'] = this.technologyMonthly(dummy);

    dummy['ipAddressMonthly'] = this.ipAddressMonthly(dummy);

    dummy['slaLevelMonthly'] = this.slaLevelMonthly(dummy);

    dummy['supportTimeMonthly'] = this.supportTimeMonthly(dummy);

    dummy['routerUnique'] = this.routerUnique(dummy);

    dummy['totalMonthlyCost'] = this.calculateTotalMonthly(dummy);

    dummy['totalUniqueCost'] = this.calculateUnique(dummy);

    this.api.postInternet(this.dataStorageService.currentState.offerID, dummy).then((response) => {
      this.dataStorageService.currentState.PPinternetCyberlink.internet.push(response);
    });
  }

  removeInternetConnClick(i: number) {
    const internet = this.dataStorageService.currentState.PPinternetCyberlink.internet[i];
    this.api.deleteInternet(this.dataStorageService.currentState.offerID, internet.id)
      .then(() => this.dataStorageService.currentState.PPinternetCyberlink.internet.splice(i, 1));
  }

  setValue(i: number, event: any, field: string, bandwidth?: string) {
    this.dataStorageService
      .currentState
      .PPinternetCyberlink
      .internet[i][field] = event.target.value;

    const cyberlinkElement = this.dataStorageService.currentState.PPinternetCyberlink.internet[i];


    if (field === 'technology') {
      this.dataStorageService
        .currentState
        .PPinternetCyberlink
        .internet[i]['bandwidth'] = bandwidth;
    }

    if(field === 'slaLevel' && cyberlinkElement.slaLevel.includes("Unmanaged")) {
      //sla is managed, auto select managed router
      cyberlinkElement.router = "No router";
      cyberlinkElement.ipAddress = "DHCP";
    }else if(field === 'slaLevel' && cyberlinkElement.slaLevel.includes("Managed")) {
      //sla is managed, auto select managed router
      cyberlinkElement.router = "Managed Router";
      cyberlinkElement.ipAddress = "4 static IP (included)";
    }


    cyberlinkElement['dslMonthlyCost'] = this.dslMonthly(cyberlinkElement);

    cyberlinkElement['simMonthlyCost'] = this.simMonthly(cyberlinkElement);

    cyberlinkElement['simUniqueCost'] = this.simUnique(cyberlinkElement);

    cyberlinkElement['endToendMonthlyCost'] = this.endToendTimeMonthly(cyberlinkElement);

    cyberlinkElement['technologyMonthly'] = this.technologyMonthly(cyberlinkElement);

    cyberlinkElement['ipAddressMonthly'] = this.ipAddressMonthly(cyberlinkElement);

    cyberlinkElement['slaLevelMonthly'] = this.slaLevelMonthly(cyberlinkElement);

    cyberlinkElement['slaLevelUnique'] = this.slaLevelUnique(cyberlinkElement);

    cyberlinkElement['supportTimeMonthly'] = this.supportTimeMonthly(cyberlinkElement);

    cyberlinkElement['routerUnique'] = this.routerUnique(cyberlinkElement);

    cyberlinkElement['totalMonthlyCost'] = this.calculateTotalMonthly(cyberlinkElement);

    cyberlinkElement['totalUniqueCost'] = this.calculateUnique(cyberlinkElement);

    this.api.putInternet(this.dataStorageService.currentState.offerID, cyberlinkElement);
  }

  toTranslate(tech: string): string {
    return tech.split(' ')[0];
  }

  techAbbreviation(tech: string): string {
    return tech.split(' ')[1];
  }

  technologyMonthly(i: Internet) {
    const option = this.dataStorageService.ispPricingCYBERLINK.filter((e) => {
      return e.technology === i.technology;
    })
      .filter((e) => {
        return e.bandwidth === i.bandwidth;
      });
    return 0 + option[0].monthlyCost;
  }

  ipAddressMonthly(i: Internet): number {
    const ip = this.dataStorageService.addressCYBERLINK.filter((e) => {
      return e.option === i.ipAddress;
    });
    return 0 + ip[0].monthlyCost;
  }

  slaLevelMonthly(i: Internet): number {
    const sla = this.dataStorageService.slaCYBERLINK.filter((e) => {
      return e.option === i.slaLevel;
    });
    if (sla.length === 0) {
      return  i.slaLevelMonthly;
    }
    return sla[0].monthlyCost;
  }
  slaLevelUnique(i: Internet): number {
    const sla = this.dataStorageService.slaCYBERLINK.filter((e) => {
      return e.option === i.slaLevel;
    });
    if (sla.length === 0) {
      return  i.slaLevelMonthly;
    }
    return sla[0].uniqueCost;
  }

  checkSlaOption(i: Internet): boolean {
    const sla = this.dataStorageService.slaCYBERLINK.filter((e) => {
      return e.option === i.slaLevel;
    });
    if (sla.length === 0) {
      return true ;
    }
    return false;
  }


  supportTimeMonthly(i: Internet): number {
    const supportTime = this.dataStorageService.supportTimeCYBERLINK.filter((e) => {
      return e.option === i.supportTime;
    });
    return 0 + supportTime[0].monthlyCost;
  }


  routerUnique(i: Internet): number {
    const routers = this.dataStorageService.typeOfRouterCYBERLINK.filter((e) => {
      return e.option === i.router;
    });
    if (!routers[0])
      return 0;

    return routers[0].uniqueCost;
  }

  endToendTimeMonthly(i: Internet): number {
    const entoend = this.dataStorageService.endtoend[0];
    let addEND = 0 ;
    if (i.checkendtoend) {
      addEND = entoend.monthlyCost;
    }
    return addEND ;
  }

  simMonthly(i: Internet): number {
    const sim = this.dataStorageService.mobileFallback.filter((e) => {
      return e.option === 'Carte-SIM';
    });
    let addsim = 0 ;
    if (i.checkSim) {
      addsim = 0 + sim[0].monthlyCost;
    }
    return addsim;
  }

  simUnique(i: Internet): number {
    const sim = this.dataStorageService.mobileFallback.filter((e) => {
      return e.option === 'Carte-SIM';
    });
    let addsim = 0 ;
    if (i.checkSim) {
      addsim = 0 + sim[0].uniqueCost;
    }
    return addsim;
  }

  dslMonthly(i: Internet): number {
    const sim = this.dataStorageService.mobileFallback.filter((e) => {
      return e.option === 'connexion-DSL';
    });
    let addsim = 0 ;
    if (i.checkDsl) {
      addsim = 0 + sim[0].monthlyCost;
    }
    return addsim;
  }



  calculateTotalMonthly(i: Internet): number {
    return 0 + (this.technologyMonthly(i) + this.ipAddressMonthly(i) + this.slaLevelMonthly(i) + this.supportTimeMonthly(i) + this.endToendTimeMonthly(i) + this.simMonthly(i) + this.dslMonthly(i));
  }

  calculateUnique(i: Internet): number {
    return 0 + (this.routerUnique(i) + this.simUnique(i) + this.slaLevelUnique(i)) ;
  }


  filterIps(slaLevel: string) {
    if(slaLevel == 'Unmanaged'){
      //returning normal IP set for Unmanaged SLA without the free included 4 static one
      const filteredIps = new Set();
      this.IPaddress.map(e => {
        if(!e.includes('4 static IP (included)')){
          filteredIps.add(e);
        }
      });
      return Array.from(filteredIps);

    } else {
      //returning only 4 Ip or more for free for all managed services
      const filteredIps = new Set();
      this.IPaddress.map(e => {
        if(e.includes('4 static IP (included)') || e.includes('8 static IP') || e.includes('16 static IP') || e.includes('32 static IP') ){
          filteredIps.add(e);
        }
      });
      return Array.from(filteredIps);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/content/new-offer/internet-cyberlink/cyber-internet/cyber-internet.component.ts